import React from 'react'
import GlobalCSS from 'src/components/GlobalCSS'
/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { BreakPoint } from 'src/components/shared/CssValues'
import SEO from 'src/components/seo'
import SubPageTopLayout from 'src/components/organisms/SubPageTopLayout'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'
import Container from 'src/components/atoms/policy/Container'
import Contents from 'src/components/atoms/policy/Contents'
import Content from 'src/components/atoms/policy/Content'
import ChapterName from 'src/components/atoms/policy/ChapterName'
import ListUl from 'src/components/molecules/ListUl'

const PrivacyPolicy = () => {
  return (
    <div>
      <SEO title="プライバシーポリシー（個人情報保護方針）" />
      <Container>
        <GlobalCSS />
        <Header />
        <SubPageTopLayout
          title="プライバシーポリシー（個人情報保護方針）"
          heading="PRIVACY POLICY"
        />
        <ContentsWrapper>
          <Contents>
            <Content>
              当社は、「個人情報の保護に関する法律」（平成15年法律第57号。以下「個人情報保護法」といいます。）に基づく個人データの適正な取扱いの確保のため、本プライバシーポリシーを定め、これを遵守します。なお、本プライバシーポリシーにおいて別段の定めがない限り、本プライバシーポリシーにおける用語の定義は、個人情報保護法の定めに従います。
            </Content>

            <ChapterName>1. 当社の名称・住所・代表者</ChapterName>
            <Content>
              名称：コミューン株式会社
              <br />
              住所：東京都品川区西五反田４−３１−１８　目黒テクノビル２F
              <br />
              代表者：高田優哉
            </Content>

            <ChapterName>2. 法令等の遵守について</ChapterName>
            <Content>
              当社は、個人情報保護の実現のため、個人情報保護法、各省庁ガイドラインその他関連する法令等を遵守します。
            </Content>

            <ChapterName>3. 個人情報の取得</ChapterName>
            <Content>
              当社は、当社ウェブサイト又は当社が提供するアプリケーション内（以下「当社媒体」といいます。）で提供者本人の氏名や連絡先情報、法人に関する情報などを取得します。
            </Content>

            <ChapterName>4. 個人情報の利用目的</ChapterName>
            <Content>
              当社は、個人情報保護法その他の法令の法令により許容される場合を除き、取得した個人情報を以下の目的の範囲内で利用します。当社は、取得した個人情報を取得当初の目的の範囲を超えて利用することはありません。特に、当社サービス提供先の顧客情報を取得する同期先サイトのログイン情報は、「commmune」をはじめとする当社サービス提供の一部として、ユーザー情報を取得する目的を超えて利用することはありません。また、当社が個人情報を第三者から間接的に取得する場合は、当該第三者が本人から適正に取得したものであるかどうかを確認した上で、以下の目的の範囲内で利用します。
              <br />
              なお、当社媒体から取得した個人情報をオフラインやその他の情報源から得た情報で補足する場合があります。
              <ol>
                <li>(1) 従業員・退職者に関する個人情報
                  <ListUl>
                    {[
                      '業務の進捗状況、緊急時の安否等の確認および連絡のため',
                      '従業員への給与支給、人事情報、労務情報、健康情報の適切な管理のため',
                      '福利厚生の利用に必要な情報の提供のため',
                      '退職者への退職関連書類の送付、必要な手続きの確認および連絡のため'
                    ]}
                  </ListUl>
                </li>
                <li>(2) 採用応募者に関する個人情報
                  <ListUl>
                    {[
                      '採用応募者への求人情報、面談日時、入社手続等の情報提供および連絡のため',
                      '採用エージェント等への採用合否、スケジュール調整等の確認および連絡のため'
                    ]}
                  </ListUl>
                </li>
                <li>(3) お取引先等に関する個人情報
                  <ListUl>
                    {[
                      '業務上必要な連絡、商談等実施のため',
                      '郵送、支払先等の取引先情報の管理のため'
                    ]}
                  </ListUl>
                </li>
                <li>(4) 当社サービスのご利用者に関する個人情報
                  <ListUl>
                    {[
                      '当社サービスの機能、仕様、お問い合わせ、更新情報等のご案内のため',
                      '当社サービスの提供および個々の利用権限等の管理のため',
                      '当社サービスの利用状況、稼働状況の把握および管理のため',
                      '当社サービスの改善、新規開発のため',
                      '当社サービスに関わる機能、利用状況等のアンケート実施のため',
                      '個人を特定できないようにデータ加工した上で、当社サービスに関する統計データ・マーケティング資料の作成、利用、提供のため'
                    ]}
                  </ListUl>
                </li>
              </ol>
            </Content>

            <ChapterName>5. 取得当初の目的と異なった利用に該当する場合について</ChapterName>
            <Content>
              当社は、個人情報保護法その他の法令で許容される場合を除き、取得した個人情報を取得当初の目的の範囲を超えて利用することはありません。当初の利用目的の範囲を超えて個人情報を利用することになった場合には、提供者本人の事前の同意を得たうえで利用します。
            </Content>

            <ChapterName>6. 個人情報の第三者提供について</ChapterName>
            <Content>
              当社は、取得した個人情報を提供者本人からの事前の同意を得ることなく第三者に提供することはありません。ただし、個人情報保護法その他の法令が定める場合及び以下の場合は除きます。
              <ListUl>
                {[
                  '法令に基づき提供を求められた場合',
                  '人の生命、身体又は財産の保護のために必要な場合であって、提供者本人の同意を得ることが困難である場合',
                  '国、地方自治体、裁判所、警察その他法律や条例などで認められた権限を持つ機関が正当な権限に基づく事務を遂行する上で協力する必要がある場合であって、提供者の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合',
                  '当初の利用目的の範囲内で外部の委託先との個人情報の共有が必要になった場合',
                ]}
              </ListUl>
            </Content>

            <ChapterName>7. 個人情報の共同利用について</ChapterName>
            <Content>
              当社は、取得した個人情報を共同利用することはありません。
            </Content>

            <ChapterName>8. ログファイル・クッキー・ウェブビーコン等の技術的情報について</ChapterName>
            <Content>
              当社媒体では、ログファイルの収集、クッキーの送信（広告の効果測定を目的とした第三者サーバーからのクッキー送信を含む）、ウェブビーコンの設置などにより皆様のIPアドレス、アクセス回数、ご利用ブラウザ、OSその他利用端末などの情報を収集しています。スマートフォンアプリをご利用の場合、アプリからご利用の端末のID、wi-fi接続に関する情報も取得致します。クッキーは皆様がご利用のブラウザの設定によって受け入れを拒否することができますが、その場合にはウェブサイトのサービスの一部がご利用頂けなくなる可能性があります。これらの情報は、当社媒体の利用傾向の分析や問題発生時の原因究明を目的に収集しており、個人を特定する目的の利用はしておりません。
              <br />
              また当社媒体では利用状況の分析にGoogle社が提供するGoogleアナリティクス及びFirebaseを使用しています。Googleアナリティクス及びFirebaseではクッキーやウェブビーコンを利用して、個人を識別できない形式で当社媒体の利用データを収集しています。Googleアナリティクス及びFirebase内でのクッキーの利用に関してはGoogleのプライバシーポリシーと規約に則っています。
              <br />
              GoogleアナリティクスおよびFirebaseによるデータ収集の仕組みや無効化の方法はこちらをご覧ください。
              <br />
              Googleポリシーと規約：<a href="https://policies.google.com/technologies/partner-sites?hl=ja" target='_blank'>https://policies.google.com/technologies/partner-sites?hl=ja</a>
              <br />
              Firebaseの利用規約：<a href="https://firebase.google.com/terms" target='_blank'>https://firebase.google.com/terms</a>
            </Content>

            <ChapterName>9. 安全管理措置について</ChapterName>
            <Content>
              当社では、個人データの適正な取扱いの確保のため、「法令等の遵守について」「プライバシーポリシーの変更・更新通知及び苦情について」等についての基本方針として、本プライバシーポリシーを策定しております。セキュリティや個人情報保護に関する社内教育等を定期的に実施し、従業員の個人情報保護への意識の向上、啓発に努めており、個人データについての秘密保持に関する事項を雇用契約又は就業規則に記載しております。また、当社は、取得した個人情報の保護のためにあらゆる予防措置を講じ、オンライン・オフラインの両方において保護されます。管理フローの策定、個人情報取扱業務を実施するエリアの制限などによる組織的、物理的安全管理措置に加え、ファイヤウォール、不正侵入検知、SSLなどの技術的安全管理措置を実施し、個人情報の取り扱いに細心の注意を図ると共に、業務上必要とされる権限を与えられた者のみがアクセス可能としています。
              <br />
              当社は、取得した個人情報を日本および米国のデータサーバー上に保管しています。当社は、米国における個人情報保護に関する制度等につき把握した上でいずれのデータサーバー上においても不正アクセス予防等の技術的安全管理措置のほか、保管業務以外の利用を禁止する旨を契約上の義務として課す等の適正な安全管理措置の下で管理しています。
            </Content>

            <ChapterName>10. 漏洩時の報告等</ChapterName>
            <Content>
              当社は、当社の取り扱う個人情報の漏洩、滅失、毀損等の事態が生じた場合において、個人情報保護法の定めに基づき個人情報保護委員会への報告及び本人への通知を要する場合には、かかる報告及び通知を行います。
            </Content>

            <ChapterName>11. 個人情報等の開示、訂正等、利用停止等の請求について</ChapterName>
            <Content>
              当社は、個人情報保護法その他の法令の定めに従い、個人情報の開示、訂正等、利用停止等及び第三者提供の停止の請求があった場合には、所定の手続きでご本人様確認の上、速やかに請求に応じます。開示、訂正等、利用停止等の請求は以下のメールアドレスよりご連絡いただきますようお願いいたします。また、開示、訂正等は、「commmune」をはじめとする当社サービスログイン後の「ユーザー情報の編集」で自ら確認、訂正等を行うこともできます。本項の定めは、本人が識別される個人データの第三者への提供又は第三者からの提供に関し、個人情報保護法に基づき作成した記録についても適用されます。
              <br />
              メールアドレス：info@commmune.jp
            </Content>

            <ChapterName>12. リンク先の個人情報の取扱いについて</ChapterName>
            <Content>
              当社媒体には、外部のリンクが存在し得ます。本プライバシーポリシーの適用範囲は「当社のウェブサイト群」及びスマートフォンアプリである「commmune」をはじめとする「当社のアプリ群」のみとなりますので、外部のウェブサイト等での個人情報の取扱についてはリンク先ウェブサイトのプライバシーステートメントをご参照ください。ただし、アンケートについては、外部のASPを使用しており「当社のウェブサイト群」以外のドメインに遷移することがあります。そちらでの個人情報の取扱に関しては本プライバシーポリシーの適用範囲になります。
            </Content>

            <ChapterName>13. プライバシーポリシーの変更・更新通知及び苦情について</ChapterName>
            <Content>
              当社は、当サービスを定期的に見直し、改善を行います。それに伴い、プライバシーポリシーを変更する場合があります。プライバシーポリシーに重要な変更がある場合には、当社媒体上で告知します。また、当社の個人情報の取扱に関してのお問合わせ・苦情等は以下の連絡先までご連絡ください。
            </Content>

            <Content>
              コミューン株式会社
              <br />
              東京都品川区西五反田4-31-18 目黒テクノビル2F
              <br />
              info@commmune.jp
            </Content>
          </Contents>

          <hr />
              
          <input type="checkbox" id="toggle01" css={toggle} />
          <label htmlFor="toggle01"><p id="readmore" css={readmore}>令和４年４月１日改定前までのプライバシーポリシーはこちら</p></label>

          <div id="archves20220401" css={archves20220401}>
            <ChapterName>1 法令などの遵守について</ChapterName>

            <Content>
              当社は、個人情報保護の実現のため、個人情報保護法、各省庁ガイドラインその他関連する法令等を遵守いたします。
            </Content>

            <ChapterName>2 個人情報の収集方法とその目的について</ChapterName>

            <Content>
              当社は当ウェブサイト及び当アプリ内で氏名や連絡先情報、法人に関する情報などを収集します。
              <br />
              当社が取得した個人情報は、以下の目的の範囲内で使用します。
              <br />
              <ListUl>
                {[
                  'お取引先等の個人情報は、業務連絡及び業務の円滑な遂行のため利用します。',
                  '従業員・退職者に関する個人情報は、雇用及び人事管理のため利用します。',
                  '採用応募者の方の個人情報は、選考および採否に関する連絡のため利用します。',
                  'commmune事業に関わる個人情報は、サービスの提供及び管理、サービス利用状況・稼働状況の把握、当社のサービス案内、当社のサービス改善及び開発、問い合わせ対応、サービス改善に関わるアンケート実施、利用者に合わせたカスタマイズコンテンツの提供、個人を特定できないようデータ加工した上でのサービスに関する統計データ・マーケティング資料の作成・利用・提供のため利用します。'
                ]}
              </ListUl>
              尚、当ウェブサイト及び当アプリから取得した個人情報をオフラインやその他の情報源から得た情報で補足する場合があります。当ウェブサイト及び当アプリで収集した個人情報を収集当初の目的の範囲を超えて利用することはありません。特に、弊社サービス提供先の顧客情報を取得する同期先サイトのログイン情報は、「commmune」をはじめとする弊社サービス提供の一部として、ユーザー情報を取得する目的を超えて利用することはありません。
              <br />
              また当社が個人情報を第三者から間接的に取得する場合は、当該第三者が本人から適正に取得したものであるかどうかを確認した上で、上記目的の範囲内で利用します。
            </Content>

            <ChapterName>
              3 それらの個人情報の第三者への提供について
            </ChapterName>

            <Content>
              当社はお預かりした個人情報を皆様からの事前の同意を得ることなく第三者に提供することは行いません。ただし以下の場合は除きます。
              <br />
              <ListUl>
                {[
                  '当初の利用目的の範囲内で外部の委託先との個人情報の共有が必要になった場合',
                  '法的手続きに基づく開示請求があった場合'
                ]}
              </ListUl>
              内、委託先への個人情報の提供が必要になった際には、委託先に対し情報管理に関する適切な監督を行ったうえで提供を行います。
            </Content>

            <ChapterName>
              4 ログファイル・クッキー・ウェブビーコン等の技術的情報について
            </ChapterName>

            <Content>
              当ウェブサイトでは、ログファイルの収集、クッキーの送信（広告の効果測定を目的とした第三者サーバーからのクッキー送信を含む）、ウェブビーコンの設置などにより皆様のIPアドレス、アクセス回数、ご利用ブラウザ、OSその他利用端末などの情報を収集しています。スマートフォンアプリをご利用の場合、アプリからご利用の端末のID、wi-fi接続に関する情報も取得致します。クッキーは皆様がご利用のブラウザの設定によって受け入れを拒否することができますが、その場合にはウェブサイトのサービスの一部がご利用頂けなくなる可能性があります。これらの情報は、当ウェブサイト及び当アプリの利用傾向の分析や問題発生時の原因究明を目的に収集しており、個人を特定する目的の利用はしておりません。
              <br />
              また当ウェブサイトではサイト利用状況の分析にGoogle
              アナリティクスを使用しています。Google
              アナリティクスではクッキーやウェブビーコンを利用して、個人を識別できない形式で当社サイト利用データを収集しています。Google
              アナリティクス内でのクッキーの利用に関してはGoogle
              のプライバシーポリシーと規約に則っています。
              <br />
              Google
              アナリティクスによるデータ収集のしくみや無効化の方法はこちらをご覧ください。
              <br />
              Google
              ポリシーと規約：https://policies.google.com/technologies/partner-sites?hl=ja
            </Content>

            <ChapterName>
              5
              それら個人情報に関する本人からの開示、訂正、利用停止等の方法について
            </ChapterName>

            <Content>
              当社にご提供頂いた企業情報・個人情報の確認・訂正などは以下のメールアドレス宛にご連絡頂くか、またはcommmuneをはじめとする弊社サービスログイン後の「ユーザー情報の編集」で自ら修正・確認を行うことが出来ます。ご本人であることを確認したうえで対応いたします。
              <br />
              info@commmune.jp
            </Content>

            <ChapterName>6 開示に対する法的免責事項について</ChapterName>

            <Content>
              法律の定めにより、国、地方自治体、裁判所、警察その他法律や条例などで認められた権限を持つ機関より要請があった場合には、これに応じて皆様の許可なく情報を開示することがあります。
            </Content>

            <ChapterName>7 セキュリティ対策について</ChapterName>

            <Content>
              当社では、セキュリティや個人情報保護に関する社内教育等を定期的に実施し、従業員の個人情報保護への意識の向上、啓発に努めています。また、当社は、収集した個人情報保護のためにあらゆる予防措置を講じ、オンライン・オフラインの両方において保護されます。ファイヤウォール、不正侵入検知、SSLなどの技術を用いて個人情報の取り扱いには細心の注意を図ると共に、業務上必要とされる権限を与えられた者のみがアクセス可能としています。
            </Content>

            <ChapterName>
              8 収集当初の目的と異なった利用に該当する場合について
            </ChapterName>

            <Content>
              当社では収集時点のプライバシーステートメントに記載されている利用目的の範囲を超えて皆様の個人情報を利用することはありません。もし当初の利用目的の範囲を超えて個人情報を利用することになった際には、事前に皆様の同意を得たうえで行います。
            </Content>

            <ChapterName>9 リンク先の個人情報の取扱いについて</ChapterName>

            <Content>
              当社ウェブサイト並びに「commmune」をはじめとする当社アプリには外部のリンクが存在し得ます。本プライバシーステートメントの適用範囲は「当社のウェブサイト群」及びスマートフォンアプリである「commmune」をはじめとする「当社のアプリ群」のみとなりますので、外部のウェブサイト等での個人情報の取扱についてはリンク先ウェブサイトのプライバシーステートメントをご参照ください。ただし、アンケートについては、外部のASPを使用しており「当社のウェブサイト群」以外のドメインに遷移することがあります。そちらでの個人情報の取扱に関しては本プライバシーポリシーの適用範囲になります。
            </Content>

            <ChapterName>
              10 プライバシーステートメントの変更・更新通知及び苦情について
            </ChapterName>

            <Content>
              当社は、当サービスを定期的に見直し、改善を行います。それに伴い、プライバシーステートメントを変更する場合があります。プライバシーステートメントに重要な変更がある場合には、当ウェブサイト上で告知します。また当社の個人情報の取扱に関してのお問合わせ・苦情等は以下の連絡先までご連絡ください。
            </Content>

            <Content>
              コミューン株式会社
              <br />
              東京都品川区西五反田4-31-18 目黒テクノビル2F
              <br />
              info@commmune.jp
            </Content>
          </div>
        </ContentsWrapper>
        <Footer />
      </Container>
    </div>
  )
}

const readmore = css`
  position: relative;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.4;
  color: #22475d;
  margin: 20px 0 120px;
  padding-left: 16px;
  cursor: pointer;
  &::before {
    position: absolute;
    content: '';
    top: 4px;
    bottom: 0;
    left: 0;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 0 5px 8px;
    border-color: transparent transparent transparent #22475d;
  }
`
const toggle = css`
  display: none;
  &:checked {
    & ~ #archves20220401 {
      display: block;
    }
    & + label #readmore {
      margin-bottom: 20px;
      &::before {
        transform:rotate(90deg);
      }
    }
  }
`

const archves20220401 = css`
  display: none;
  padding-left: 32px;
  @media (max-width: ${BreakPoint.MOBILE}) {
    padding-left: 16px;
  }
  margin-bottom: 120px;
  border-left: 3px solid #22475d;
`

export default PrivacyPolicy
